<template>
  <div class="row">
    <div class="col-12" v-if="!loading">
      <form class="form-checklist" @submit="save">
        <div
          class="
            form-checklist__categories form-checklist__categories__list
            mb-3
          "
          v-for="category in checklistCategories"
          :key="category.id"
        >
          <div
            class="form-checklist__models__wrapper"
            v-if="category.checklist_items.length > 0"
          >
            <checklist-header :title="category.name"></checklist-header>

            <div
              class="form-checklist__models form-checklist__models__list"
              v-for="model in category?.checklist_items"
              :key="model.id"
            >
              <checklist-model-item
                :model="model"
                :description="model.name"
                :item-value="responses[model.id].value"
                @update:itemValue="
                  ($event) => handleItemChanged(model.id, $event)
                "
                @update:subitemValue="handleSubitemChanged"
              ></checklist-model-item>
            </div>
          </div>
        </div>

        <button class="btn btn-dark mt-3">{{ submit_text }}</button>
      </form>
    </div>
  </div>
</template>

<script>
  import ChecklistHeader from './components/ChecklistHeader.vue'
  import ChecklistModelItem from './components/ChecklistModelItem.vue'

  export default {
    components: { ChecklistHeader, ChecklistModelItem },
    data() {
      return {
        checklistCategories: [],
        responses: {},
        machine: null,
        loading: true,
        submit_text: '',
        render: 0,
      }
    },
    async mounted() {
      var app = this
      app.submit_text = 'Cadastrar'

      await app.getMachine()
      await app.listChecklistItems()
      await app.loadChecklistResponses()

      this.loading = false
    },
    methods: {
      async getMachine() {
        var app = this
        const machineId = app.$route.params.machineId

        app.axios
          .get(`/api/machines/get/${machineId}`)
          .then(({ data }) => {
            app.machine = data.data
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            app.loading = false
          })
      },
      async listChecklistItems() {
        var app = this

        app.axios
          .get('/api/checklist/categories/all')
          .then(function (response) {
            app.checklistCategories = response.data.data

            app.checklistCategories.forEach((category) => {
              category.checklist_items.forEach((model) => {
                app.responses[model.id] = {
                  value: null,
                  id: model.id,
                }

                if (model?.checklist_subitems?.length > 0) {
                  app.responses[model.id].subitems = {}
                }

                model.checklist_subitems.forEach((subitem) => {
                  app.responses[model.id].subitems[subitem.id] = {
                    value: null,
                    id: subitem.id,
                  }
                })
              })
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      async loadChecklistResponses() {
        //FIXME: Valores de resposta são carregados para o estado do componente,
        //mas os inputs não detectam mudança no estado para apresentarem visualmente
        var app = this
        const machineId = app.$route.params.machineId

        app.axios
          .get(`/api/machines/${machineId}/checklist/get-by-machine`)
          .then(function (response) {
            if (response.data.data.responsesData) {
              app.responses = response.data.data.responsesData
              app.responses = { ...app.responses }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      handleItemChanged(modelId, $event) {
        this.responses[modelId].value = $event

        //Seta valor de subitens para null
        if (
          this.responses[modelId]?.subitems &&
          typeof this.responses[modelId]?.subitems === 'object'
        ) {
          for (const subitemId in this.responses[modelId].subitems) {
            this.responses[modelId].subitems[subitemId] = {
              ...this.responses[modelId].subitems[subitemId],
              value: null,
            }
          }
        }

        this.responses = { ...this.responses }
      },
      handleSubitemChanged($event) {
        this.responses[$event.modelId].subitems[$event.subitemId].value =
          $event.value
        //PROBLEMAS DE REATIVIDADE
        //SE O OBJETO NÃO MUDAR A REFERÊNCIA, NÃO HÁ REATIVIDADE
        this.responses = { ...this.responses }
      },
      async save(event) {
        event.preventDefault()
        const machineId = this.$route.params.machineId

        const data = new FormData()
        data.append('responses', JSON.stringify(this.responses))

        this.axios
          .post(`/api/machines/${machineId}/checklist/storeOrUpdate`, data, {
            headers: {
              'Content-type': 'multipart/form-data',
            },
          })
          .then(() => {
            this.$router.push({ path: `/risk-analysis` })
          })
          .catch((error) => {
            console.log({ error })
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .checklist {
    &__item,
    &__subitem {
      margin: 0;

      input[type='radio'] {
        display: none;
      }

      &.active {
        .checklist__item__icon,
        .checklist__subitem__icon {
          opacity: 1;
        }
      }

      .checklist__item__icon,
      .checklist__subitem__icon {
        opacity: 0;
      }
    }
  }
</style>
